import PagePagination from './PagePagination';

export default PagePagination;
